import teamData from "../localData/teamData.json";

const teams = (state = teamData, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
export default teams;
